<template>
  <div>
    <div v-if="!createBill || billingMethods.length" id="billingMethods">
      <h1>{{ headerTitle }}</h1>
      <div class="steps-container clearfix">
        <ul class="steps-progressbar clearfix">
          <li class="step-active">select plan</li>
          <li class="step-active">select payment</li>
          <li>confirmation</li>
        </ul>
      </div>
      <div class="billingMethods center-element clearfix">
        <div
          v-for="entry in billingMethods"
          :key="entry.id"
          class="billingMethod center-element"
        >
          {{ entry.payment_method }} ending in {{ entry.payment_last_4 }}<br />
          Expires {{ entry.payment_exp_date }} <br /><br />
          <div class="center-text">
            <a
              href="#"
              class="button button-150"
              @click.prevent="select(entry.id)"
              >Use Card</a
            >
          </div>
        </div>
      </div>
      <!-- <div class="center-full-width center-text clearfix">
        <a
          href="#"
          class="button button-200"
          @click.prevent="createBill = true">Add a Card</a>
      </div> -->
    </div>
    <AccountBillingCreateComponent
      v-if="createBill && !billingMethods.length"
      header-title="Upgrade Plan: Create New Payment Method"
      @card-created="cardCreated()"
      @cancel="createCancel()"
    />
  </div>
</template>
<script>
import AccountBillingCreateComponent from "@/components/AccountBillingCreateComponent.vue";
import api from "@/api/index";
const apiServiceBilling = new api.APIServiceBilling();

export default {
  name: "BillingMethodsList",
  components: {
    AccountBillingCreateComponent
  },
  props: {
    headerTitle: {
      default: "Manage Billing Methods",
      type: String
    }
  },
  data() {
    return {
      createBill: true,
      billingMethods: []
    };
  },
  created() {
    this.getAccountBillingMethods();
  },
  methods: {
    select: function(accountBillingID) {
      this.$emit("select-billing", accountBillingID);
    },
    cardCreated: function() {
      // should this just auto go back to upgrade ?
      this.getAccountBillingMethods();
      this.createBill = false;
    },
    createCancel: function() {
      this.$emit("cancel-billing");
      // this.$router.push('/console/dashboard/upgradeplan');
      // this.createBill = false;
    },
    getAccountBillingMethods: function() {
      apiServiceBilling.getAccountBillingMethods().then(data => {
        if (data) {
          this.billingMethods = data.data;
        }
      });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 18px;
}
h3 {
  font-size: 18px;
  margin-bottom: 0;
}
#billingMethods {
  lost-utility: clearfix;
}
.billingMethods {
  width: 300px;
  margin-top: 10px;
}
.billingMethod {
  lost-column: 1/1;
  width: 300px;
  background: #d5e3f4;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  height: 150px;
}
.white-bg {
  background: #fff;
  padding-top: 40px;
}
.addMethodContainer {
  margin-top: 15px;
}
.create-button {
  color: white;
  width: 100%;
}
.steps-container {
  width: 100%;
  margin: 30px auto;
  text-align: center;
}
.steps-progressbar {
  margin: 0 auto;
  width: 60%;
  text-align: center;
  counter-reset: step;
}
.steps-progressbar li {
  list-style-type: none;
  width: 33%;
  float: left;
  font-size: 12px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  color: #7d7d7d;
}
.steps-progressbar li:before {
  width: 30px;
  height: 30px;
  content: counter(step);
  counter-increment: step;
  line-height: 30px;
  border: 2px solid #7d7d7d;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background-color: white;
}
.steps-progressbar li:after {
  width: 100%;
  height: 2px;
  content: "";
  position: absolute;
  background-color: #7d7d7d;
  top: 15px;
  left: -50%;
  z-index: -1;
}
.steps-progressbar li:first-child:after {
  content: none;
}
.steps-progressbar li.step-active {
  color: #5584c0;
}
.steps-progressbar li.step-active:before {
  border-color: #5584c0;
}
.steps-progressbar li.step-active + li:after {
  background-color: #5584c0;
}
@media (max-width: 800px) {
  .billingMethod {
    lost-column: 1/1;
  }
  .steps-progressbar {
    width: 80%;
  }
}
@media (max-width: 640px) {
  .billingMethod {
    lost-column: 1/1;
  }
  .steps-progressbar {
    margin: 0 auto;
    width: 90%;
    text-align: center;
    counter-reset: step;
  }
}
</style>
